import React, { useMemo, useState, useEffect } from "react";
import {
  View,
  KeyboardAvoidingView,
  ActivityIndicator,
  Keyboard,
  Linking,
} from "react-native";
import {
  useStripe,
  useElements,
  CardElement,
  PaymentRequestButtonElement,
} from "@stripe/react-stripe-js";
import { MyCart, Constant } from "./Data.js";
import { Button, Text, Container } from "native-base";
import * as firebase from "firebase";

import { Input, InputGroup } from "rsuite";

import "./styles.css";

// import useResponsiveFontSize from "../../useResponsiveFontSize";
import axios from "axios";
import { useNavigation } from "@react-navigation/native";

const db = firebase.firestore();
const funcs = firebase.functions();
// funcs.useFunctionsEmulator("http://localhost:5001");

const CardForm = ({
  stripeID,
  name,
  restaurantID,
  tableID,
  totalAmount,
  subTotalAmount,
  tipAmount,
  myCart,
}) => {
  const stripe = useStripe();
  const elements = useElements();
  const navigation = useNavigation();
  const [paymentRequest, setPaymentRequest] = useState(null);
  const totalP = Math.floor(totalAmount * 100);

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (stripe) {
      const pr = stripe.paymentRequest({
        country: "US",
        currency: "usd",
        total: {
          label: "FlyBy",
          amount: totalP,
        },
        requestPayerName: true,
        requestPayerEmail: true,
      });

      // Check the availability of the Payment Request API.
      pr.canMakePayment().then((result) => {
        if (result) {
          setPaymentRequest(pr);
        }
      });
    }
  }, [stripe]);

  if (paymentRequest) {
    paymentRequest.on("paymentmethod", async (ev) => {
      const p1 = funcs
        .httpsCallable("createPaymentIntent")({
          connectedAccountID: stripeID,
          totalAmount: totalP,
        })
        .then((response) => {
          console.log("KANE-1");
          return response.data.clientSecret;
        })
        .then((clientSecret) => {
          return stripe.confirmCardPayment(
            clientSecret,
            { payment_method: ev.paymentMethod.id },
            { handleActions: false }
          );
        })
        .then((result) => {
          if (result.error) {
            console.log("KANE-E0", result.error);
            // Show error to your customer (e.g., insufficient funds)
            return Promise.reject();
          } else {
            // The payment has been processed!
            if (result.paymentIntent.status === "succeeded") {
              ev.complete("success");
              return result.paymentIntent.id;
            }
          }
        })
        .then((orderID) => {
          const myCartFormatted = myCart.map((item) => {
            var str = item.title;
            if (item.comment && item.comment !== "") {
              str = str.concat(" (").concat(item.comment).concat(")");
            }
            return str;
          });
          return db
            .collection("Restaurants")
            .doc(restaurantID)
            .collection("Orders")
            .doc(orderID)
            .set({
              timestamp: firebase.firestore.Timestamp.fromDate(new Date()),
              table: tableID,
              totalAmount: parseFloat(totalAmount),
              subtotalAmount: parseFloat(subTotalAmount),
              tipAmount: parseFloat(tipAmount),
              itemArray: myCartFormatted,
              orderID: orderID,
              donateTo: "1",
            })
            .then(() => {
              setIsLoading(false);
              Keyboard.dismiss();
              navigation.navigate("Success", {
                restaurantID: restaurantID,
                orderID: orderID,
                subTotalAmount: subTotalAmount,
              });
            });
        })
        .catch((error) => {
          ev.complete("fail");
          console.log("KANE-ER");
        });

      return p1;
    });

    const options = {
      paymentRequest,
      style: {
        paymentRequestButton: {
          type: "default",
          height: "52px",
          marginBottom: 16,
        },
      },
    };
    return (
      <View
        style={{
          flex: 1,
          flexDirection: "column",
          height: "100%",
          justifyContent: "flex-end",
          backgroundColor: Constant.backgroundColor2,
        }}
      >
        <TermsPrivacyElement />
        <View
          style={{
            backgroundColor: "clear",
            flexGrow: 1,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Text
            style={{
              fontFamily: Constant.fontFamily,
              fontSize: 20,
              fontWeight: "bold",
            }}
          >
            {name}
            {console.log("JEEP", paymentRequest)}
          </Text>
          <Text
            style={{
              fontFamily: Constant.fontFamily,
              fontSize: 18,
              fontWeight: "bold",
              marginTop: 2,
            }}
          >
            ${totalAmount}
          </Text>
        </View>
        <View>
          <PaymentRequestButtonElement options={options} />
        </View>
      </View>
    );
  }

  const handleSubmit = async () => {
    event.preventDefault();

    const payload = JSON.stringify({});

    if (!stripe || !elements) {
      // Stripe.js has not yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }

    console.log("KANE-0");
    setIsLoading(true);

    const p1 = funcs
      .httpsCallable("createPaymentIntent")({
        connectedAccountID: stripeID,
        totalAmount: totalP,
      })
      .then((response) => {
        console.log("KANE-1");
        return response.data.clientSecret;
      })
      .then((clientSecret) => {
        return stripe.confirmCardPayment(clientSecret, {
          payment_method: {
            card: elements.getElement(CardElement),
          },
        });
      })
      .then((result) => {
        if (result.error) {
          console.log("KANE-E0", result.error);
          // Show error to your customer (e.g., insufficient funds)
          return Promise.reject();
        } else {
          // The payment has been processed!
          if (result.paymentIntent.status === "succeeded") {
            return result.paymentIntent.id;
          }
        }
      })
      .then((orderID) => {
        const myCartFormatted = myCart.map((item) => {
          var str = item.title;
          if (item.comment && item.comment !== "") {
            str = str.concat(" (").concat(item.comment).concat(")");
          }
          return str;
        });
        return db
          .collection("Restaurants")
          .doc(restaurantID)
          .collection("Orders")
          .doc(orderID)
          .set({
            timestamp: firebase.firestore.Timestamp.fromDate(new Date()),
            table: tableID,
            totalAmount: parseFloat(totalAmount),
            subtotalAmount: parseFloat(subTotalAmount),
            tipAmount: parseFloat(tipAmount),
            itemArray: myCartFormatted,
            orderID: orderID,
            donateTo: "1",
          })
          .then(() => {
            setIsLoading(false);
            Keyboard.dismiss();
            navigation.navigate("Success", {
              restaurantID: restaurantID,
              orderID: orderID,
              subTotalAmount: subTotalAmount,
            });
          });
      })
      .catch((error) => {
        setIsLoading(false);
        Keyboard.dismiss();
        alert("Payment could not be processed.");
        console.log("KANE-ER", error);
      });

    return p1;
  };

  return (
    <View
      style={{
        flex: 1,
        flexDirection: "column",
        height: "100%",
        justifyContent: "flex-end",
        backgroundColor: Constant.backgroundColor2,
      }}
    >
      <TermsPrivacyElement />
      <View
        style={{
          backgroundColor: "clear",
          flexGrow: 1,
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Text
          style={{
            fontFamily: Constant.fontFamily,
            fontSize: 20,
            fontWeight: "bold",
          }}
        >
          {name}
          {console.log("JEEP", paymentRequest)}
        </Text>
        <Text
          style={{
            fontFamily: Constant.fontFamily,
            fontSize: 18,
            fontWeight: "bold",
            marginTop: 2,
          }}
        >
          ${totalAmount}
        </Text>
      </View>
      <View>
        <CardCheckoutComp
          handleSubmit={handleSubmit}
          stripe={stripe}
          buttonHeight={60}
          isLoading={isLoading}
        />
      </View>
    </View>
  );
};

function CardCheckoutComp(props) {
  const options = useMemo(() => ({
    style: {
      base: {
        // fontSize: "20px",
        color: "#424770",
        letterSpacing: "0.025em",
        fontFamily: "Source Code Pro, monospace",
        "::placeholder": {
          color: "#aab7c4",
        },
      },
      invalid: {
        color: "#9e2146",
      },
    },
  }));
  var spinner;
  if (props.isLoading === true) {
    spinner = <ActivityIndicator size="small" color="white" />;
  } else {
    spinner = null;
  }
  return (
    <View
      style={{
        marginLeft: 16,
        marginRight: 16,
        marginBottom: 16,
        backgroundColor: "clear",
      }}
    >
      <CardElement
        options={options}
        onReady={() => {
          console.log("CardElement [ready]");
        }}
        onChange={(event) => {
          console.log("CardElement [change]", event);
        }}
        onBlur={() => {
          console.log("CardElement [blur]");
        }}
        onFocus={() => {
          console.log("CardElement [focus]");
        }}
      />
      <Button
        type="submit"
        onPress={props.handleSubmit}
        style={{
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: Constant.color1,
          borderRadius: 12,
          height: props.buttonHeight,
          marginTop: 0,
          marginBottom: 0,
        }}
        disabled={!props.stripe || props.isLoading}
      >
        <View
          style={{
            flex: 1,
            flexDirection: "row",
            justifyContent: "center",
          }}
        >
          <Text
            style={{
              fontWeight: "600",
              fontSize: 18,
              fontFamily: Constant.font,
              color: "#fff",
            }}
          >
            Pay
          </Text>
          {spinner}
        </View>
      </Button>
    </View>
  );
}

function TermsPrivacyElement() {
  return (
    <Text
      style={{
        textAlign: "center",
        marginTop: 12,
        fontFamily: Constant.font,
        fontSize: 12,
        color: "gray",
      }}
    >
      By continuing you agree to FlyBy
      <Text
        style={{
          color: "blue",
          fontFamily: Constant.font,
          fontSize: 12,
          color: "dodgerblue",
        }}
        onPress={() =>
          Linking.openURL(
            "https://shop.flyby.restaurant/pages/terms-of-service"
          )
        }
      >
        {" terms of service "}
      </Text>
      &
      <Text
        style={{
          color: "blue",
          fontFamily: Constant.font,
          fontSize: 12,
          color: "dodgerblue",
        }}
        onPress={() =>
          Linking.openURL("https://shop.flyby.restaurant/pages/privacy")
        }
      >
        {" privacy."}
      </Text>
    </Text>
  );
}

export default CardForm;
